// routes/FrontendRoutes.js

import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import { AccountListProvider } from "../context/AccountListContext";
import SalesAccounts from "../components/Frontend/Accounts/SalesAccounts";
import ClientsWithIndustries from "../components/Frontend/Competitors/ClientsWithIndistries";
import { CompetitorProvider } from "../context/CompetitorContext";

export const clientsWithIndustriesRoute = (
  <>
    <Route path="/client_industry" element={<MainLayout />}>
      <Route
        index
        element={
          <CompetitorProvider>
            <ClientsWithIndustries />
          </CompetitorProvider>
        }
      />
    </Route>
  </>
);
